import { Component, OnInit } from "@angular/core";
import { TableauReportService } from "../../services/Tableau-Report.service";
import * as Sentry from '@sentry/angular';
import { DashboardSettingsDTO } from "../../models/DashboardSettingsDTO";
import { Observable, Subscription } from "rxjs";
import { TableauViz } from "../../../../../../assets/js/tableau.embedding.3.latest.min";
import { DashboardService } from "../../services/Dashboard.service";

@Component({
  selector: "tableau-report",
  templateUrl: "./tableau-report.component.html",
  styleUrls: ["./tableau-report.component.css"],
})
export class TableauReportComponent implements OnInit {
  data: string;
  response: DashboardSettingsDTO[];
  options: any;
  setting: DashboardSettingsDTO;
  $setting: Observable<DashboardSettingsDTO> = new Observable();
  viz: any;
  finalUrlItem: string;
  tokenTableau: any;
  report: any;
  dashBoardSettingDTO: DashboardSettingsDTO = new DashboardSettingsDTO();

  suscription_getTableauReports: Subscription;

  constructor(
    private tableauReportService: TableauReportService,
    private dashboardService: DashboardService
  ) {}

  InitViz(): void {
    var width = window.screen.width;
    var height = window.screen.height;
    this.viz = new TableauViz();
    this.viz.src =
      this.dashBoardSettingDTO.urlServer + this.dashBoardSettingDTO.tab;
    this.viz.token = this.dashBoardSettingDTO.token;
    this.viz.width = width - 100;
    this.viz.height = height - 190;
    document.getElementById("tableauTag").appendChild(this.viz);
  }

  ngOnInit(): void {
    this.dashboardService.setLoading(true);
    this.getTableauReports();
  }

  ngOnDestroy(): void {
    if (this.suscription_getTableauReports)
      this.suscription_getTableauReports.unsubscribe();
  }

  onChangeTab(e) {
    var index = e.index;
    this.tableauReportService.Tab = index;
    this.tableauReportService.setData(this.response[e.index]);
  }
  getTableauReports() {
    this.dashboardService.getTableauReports().subscribe({
      next: (resp) => {
        if (resp.isSuccess) {
          this.dashBoardSettingDTO = resp.result[0] as DashboardSettingsDTO;
          if (this.dashBoardSettingDTO != null) this.InitViz();
        } else {
          Sentry.captureMessage('TableauReport.getTableauReports: respuesta sin éxito', { level: 'warning', extra: { response: resp } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error de Tableau', error);
      }
    });
  }
}
